import {
  childAssociations,
  isNotChildOfAnotherItem,
  isNotReplacedByAnotherItem,
  parentAssociations,
} from 'builder/Knowledge/associations/itemAssociationFunctions';

export default class CompetencyTree {
  itemsById = {};
  itemsByTitleKey = {};
  immediateChildrenByParentId = {};
  allChildrenByParentId = {};
  itemsWithoutParents = [];
  competencyDocumentId = null;
  parentsWithoutChildren = [];
  parentIdsWithChildren = [];

  constructor(competencyDocument) {
    this.updateDocument(competencyDocument);
  }

  updateDocument = (competencyDocument) => {
    const filteredItems = competencyDocument.items.filter(isNotReplacedByAnotherItem);

    // Populate immediate children
    this.parentsWithoutChildren = [];
    this.parentIdsWithChildren = [];
    filteredItems.forEach((item) => {
      this.itemsById[item.id] = item;
      this.itemsByTitleKey[item.titleKey] = item;
      this.immediateChildrenByParentId[item.id] = childAssociations(item).map((asc) => asc.originItemId);
      if(this.immediateChildrenByParentId[item.id].length > 0) {
        this.parentIdsWithChildren[item.id] = item.id;
      }
      if(childAssociations(item).length === 0 && parentAssociations(item).length === 0){
        this.parentsWithoutChildren[item.id] = item;
      }
    });
    
    // walk from root items down to build 'all children' map.
    this.itemsWithoutParents = filteredItems.filter(isNotChildOfAnotherItem).map(({ id }) => id) || [];
    this.competencyDocumentId = competencyDocument.id;
    this.itemsWithoutParents.forEach((id) => {
      this.buildDeepChildrenMap(this.allChildrenByParentId, this.immediateChildrenByParentId, id);
    });
  }

  buildDeepChildrenMap = (allChildrenByParentId, immediateChildrenByParentId, parentId, depth = 0) => {
    // Prevent loops
    if (depth === 7) {
      return [];
    }

    const immediateChildren = immediateChildrenByParentId[parentId];
    if (!immediateChildren) {
      return [];
    }

    // eslint-disable-next-line no-param-reassign
    allChildrenByParentId[parentId] = immediateChildren.reduce((acc, childId) => [
      ...acc,
      ...this.buildDeepChildrenMap(
        allChildrenByParentId,
        immediateChildrenByParentId,
        childId,
        depth + 1
      ),
    ], immediateChildren);

    return allChildrenByParentId[parentId] || [];
  }

  countAllItems = () => Object.keys(this.itemsById).length;
  isCompetencyDocument = (itemId) => itemId === this.competencyDocumentId;
  getRootItems = () => this.itemsWithoutParents.map(this.getItem);
  getItem = (id) => this.itemsById[id];
  getItemByTitleKey = (titleKey) => this.itemsByTitleKey[titleKey];
  getChildrenIds = (parentId) => this.immediateChildrenByParentId[parentId];
  getAllChildrenIds = (parentId) => this.allChildrenByParentId[parentId];
  getAllParentsByDeepChildId = (childId) => Object.keys(this.allChildrenByParentId).filter((parentId) => (
    this.allChildrenByParentId[parentId].includes(childId)
  ));
  getChildren = (parentId) => this.immediateChildrenByParentId[parentId].map(this.getItem).filter((item) => item !== undefined && item.id);
  hasChildren = (parentId) => (this.immediateChildrenByParentId[parentId] && this.immediateChildrenByParentId[parentId].length > 0);
  hasChild = (parentId, childId, deep = true) => (
    !!(deep ? this.allChildrenByParentId : this.allChildrenByParentId)[parentId].includes(childId)
  )
  hasAnyChild = (parentId, childIds, deep = true) => (
    !!childIds.find((childId) => this.hasChild(parentId, childId, deep))
  )
  hasParentsWithoutChildren = () => {
    if(Object.keys(this.parentsWithoutChildren).length === 0){
      return false;
    }
    return true;
  }
}
